import { pluralKey } from "../lib/pluralKey";

/**
 * Plural selection for Global Data's result count. The repo's convention is one i18n key
 * per form (`...One` beside the base key, see `msg.unreadOne`); what this adds is WHICH
 * form a count takes in each language, from the CLDR rules (`Intl.PluralRules`) rather than
 * `count === 1`, so French reads "0 résultat" / "1 résultat" / "2 résultats" while English
 * and Spanish read "0 results" / "1 result".
 *
 * The rule itself, and the guard against an untrusted `lang`, live in `lib/pluralKey`.
 */
export const totalKey = (lang, total) => pluralKey(lang, total, "gdv.total");
